export enum BoardMemberRole {
	Approver = 1,
	Voter = 2
}
